import { css } from '@emotion/css';

export const imageContainerStyles = css`
  > span {
    display: block !important;
  }
`;
